<template>
  <v-card variant="outlined">
    <v-card-title class="text-subtitle-1"> Sous-tâches </v-card-title>

    <v-divider />

    <v-list v-if="subtasks.length">
      <SubtaskItem
        v-for="subtask in subtasks"
        :key="subtask.id || subtask.name"
        :subtask="subtask"
        @remove="onRemove"
        @update="onUpdate"
      />
    </v-list>

    <v-card-text v-else class="text-grey"> Aucune sous-tâche </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { Subtask } from "@/types";
import SubtaskItem from "./SubtaskItem.vue";

const props = defineProps<{
  subtasks: Subtask[];
}>();

const emit = defineEmits<{
  (e: "remove", subtask: Subtask): void;
  (e: "update", subtask: Subtask): void;
}>();

function onRemove(subtask: Subtask) {
  emit("remove", subtask);
}

function onUpdate(subtask: Subtask) {
  emit("update", subtask);
}
</script>
